import { useSelectedCarsStore } from "~/stores/selected-cars";
import { useModalOptions } from "~/composables/modal";
import DefaultModal from "~/components/modal/core/DefaultModal.vue";
import DynamicForm from "~/components/modal/content/DynamicForm.vue";

export const useDynamicFormSchema = async (input: any) => {
  const client = useClient()
  //TODO: refactor using simple query instead of use query
  const res = await client.formkit.form.useQuery(input)
  console.log('useDynamicFormSchema',res)
  return res
}

type DynamicModalInput = {
  code: string
  carId: number
  vinFrom: string
  onRefresh: any
}

export const useDynamicModalForm = async (input: any) => {
  console.log('useDynamicModalForm',input)

  const carsStore = useSelectedCarsStore();
  const {width, reset, applySettings} = useModalOptions()

  reset()

  const formData = reactive({})

  const {data, status, error} = await useDynamicFormSchema({
    code: input.code,
    formContext: {
      //TODO: fix
      carId: input.input?.carId ? +input.input.carId : undefined,
      carIds: carsStore.cars,
      ...input?.input,
    },
    ...input.input,
    //TODO: use ref for reactivity?
    formData: formData,
  })

  if (error.value) {
    console.log(error.value)
    alert(error.value)
    throw error.value
  }

  applySettings(data.value?.settings)

  console.log('formSchema',data.value.formSchema)

  const modal = useModal({
    component: DefaultModal,
    attrs: {
      title: `modal.${input.code}.title`,
      width: width,
      onConfirm: () => modal.close(),
      onClose: () => modal.close(),
      onRefresh: () => input?.onRefresh(),
    },
    slots: {
      default: useModalSlot({
        component: DynamicForm,
        attrs: {
          ...input,
          formData: formData,
          form: data.value.form,
          onClose: () => modal.close(),
        }
      })
    },
  });
  return modal

}

export const useAction = async (formData: any, ctx: any) => {
  const { emit } = ctx
  const { input } = formData
  const command = JSON.parse(input);
  const { open } = await useDynamicModalForm({
    ...command,
    onRefresh: () => {
      if (emit) {
        emit("add");
      }
    }
  });
  return { open }
};
